import React from "react";

const DISHES = [
  {
    key: "tamil-devil",
    name: "South Asian Salt Chicken Devil",
    region: "South Asia",
    note: "Bold, spicy, packed with authentic flavour.",
    img: "https://images.pexels.com/photos/2474661/pexels-photo-2474661.jpeg?auto=compress&cs=tinysrgb&w=1600&q=80",
  },
  {
    key: "jerk",
    name: "Caribbean Jerk Chicken Bites",
    region: "Caribbean",
    note: "Smoky, sweet heat with island-inspired seasoning.",
    img: "https://images.pexels.com/photos/6107772/pexels-photo-6107772.jpeg?auto=compress&cs=tinysrgb&w=1600&q=80",
  },
  {
    key: "kofta",
    name: "Middle Eastern Spiced Lamb Kofta",
    region: "Middle East",
    note: "Rich, aromatic, and deeply satisfying.",
    img: "https://images.pexels.com/photos/20739336/pexels-photo-20739336.jpeg?auto=compress&cs=tinysrgb&w=1600&q=80",
  },
  {
    key: "soy-garlic",
    name: "East Asian Sticky Soy Garlic Wings",
    region: "East Asia",
    note: "Crispy, savoury, and irresistibly glazed.",
    img: "https://images.pexels.com/photos/29908653/pexels-photo-29908653.jpeg?auto=compress&cs=tinysrgb&w=1600&q=80",
  },
];

export const SignatureFlavours = () => {
  return (
    <section
      id="flavours"
      data-testid="flavours-section"
      className="relative bg-stone-950 py-24 sm:py-32 lg:py-40 border-t border-stone-900"
    >
      <div className="max-w-7xl mx-auto px-6 sm:px-8 lg:px-12">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 mb-20">
          <div className="lg:col-span-7">
            <p className="text-orange-500 font-sans-display text-xs uppercase tracking-[0.32em] mb-6">
              03 — Signature Flavours
            </p>
            <h2
              className="font-serif-display text-stone-50 text-4xl sm:text-5xl lg:text-6xl leading-[0.95] tracking-tight"
              data-testid="flavours-heading"
            >
              A first taste of <em className="not-italic text-orange-500">what&apos;s coming</em>.
            </h2>
          </div>
          <div className="lg:col-span-4 lg:col-start-9 self-end">
            <p className="text-stone-400 font-sans-display text-base leading-relaxed">
              Standout dishes drawn from real kitchens, real regions, and real
              recipes — refined for the way you eat now.
            </p>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 lg:gap-10">
          {DISHES.map((d, i) => (
            <article
              key={d.key}
              data-testid={`flavour-card-${d.key}`}
              className="group"
            >
              <div className="relative aspect-[4/5] overflow-hidden bg-stone-900">
                <img
                  src={d.img}
                  alt={d.name}
                  className="absolute inset-0 w-full h-full object-cover transition-transform duration-[1200ms] ease-out group-hover:scale-105"
                  loading="lazy"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-stone-950/80 via-transparent to-transparent" />
                <div className="absolute top-5 left-5 inline-flex items-center gap-2 border border-stone-50/30 backdrop-blur-md bg-stone-950/40 px-3 py-1.5">
                  <span className="font-sans-display text-[10px] uppercase tracking-[0.28em] text-stone-100">
                    {d.region}
                  </span>
                </div>
                <div className="absolute top-5 right-5 font-serif-display italic text-stone-300/80 text-sm">
                  No. 0{i + 1}
                </div>
              </div>
              <div className="mt-6 flex flex-col">
                <h3 className="font-serif-display text-stone-50 text-2xl sm:text-3xl leading-tight">
                  {d.name}
                </h3>
                <p className="font-sans-display text-stone-400 text-sm mt-3 leading-relaxed">
                  {d.note}
                </p>
              </div>
            </article>
          ))}
        </div>

        <p className="mt-16 font-serif-display italic text-stone-500 text-xl text-center">
          …and more globally inspired creations.
        </p>
      </div>
    </section>
  );
};

export default SignatureFlavours;
